import BillingAPI from '../../api/billing';

const SET_ENTITLEMENTS = 'SET_ENTITLEMENTS';
const SET_UI_FLAG = 'SET_UI_FLAG';
const SET_LAST_ERROR = 'SET_LAST_ERROR';
const OPEN_LIMIT_MODAL = 'OPEN_LIMIT_MODAL';
const CLOSE_LIMIT_MODAL = 'CLOSE_LIMIT_MODAL';

const emptyModal = () => ({
  show: false,
  entitlement: null,
});

export const state = {
  payload: null,
  uiFlags: {
    isFetching: false,
  },
  lastError: null,
  modal: emptyModal(),
};

const featuresFromPayload = payload => {
  return payload?.features || payload?.entitlements || {};
};

const normalizeEntitlement = entitlement => {
  if (!entitlement) return null;

  return entitlement.response?.data || entitlement;
};

export const getters = {
  getEntitlements(_state) {
    return _state.payload;
  },
  getFeatures(_state) {
    return featuresFromPayload(_state.payload);
  },
  getFeature: _state => featureKey => {
    return featuresFromPayload(_state.payload)[featureKey] || {};
  },
  getSummary(_state) {
    return _state.payload?.summary || {};
  },
  getCurrentPlan(_state) {
    return _state.payload?.currentPlan || null;
  },
  getBillingStatus(_state) {
    return _state.payload?.billingStatus || null;
  },
  getUIFlags(_state) {
    return _state.uiFlags;
  },
  getModal(_state) {
    return _state.modal;
  },
  isOperationallyBlocked(_state) {
    return !!_state.payload?.summary?.isOperationallyBlocked;
  },
};

export const actions = {
  fetch: async function fetchEntitlements({ commit }) {
    commit(SET_UI_FLAG, { isFetching: true });
    try {
      const response = await BillingAPI.getEntitlements();
      commit(SET_ENTITLEMENTS, response.data);
      commit(SET_LAST_ERROR, null);
      return response.data;
    } catch (error) {
      commit(SET_LAST_ERROR, error);
      return null;
    } finally {
      commit(SET_UI_FLAG, { isFetching: false });
    }
  },
  refresh({ dispatch }) {
    return dispatch('fetch');
  },
  openLimitModal({ commit }, entitlement) {
    commit(OPEN_LIMIT_MODAL, entitlement);
  },
  closeLimitModal({ commit }) {
    commit(CLOSE_LIMIT_MODAL);
  },
  handleBillingError({ dispatch }, error) {
    return dispatch('openLimitModal', error);
  },
};

export const mutations = {
  [SET_ENTITLEMENTS](_state, payload) {
    _state.payload = payload;
  },
  [SET_UI_FLAG](_state, data) {
    _state.uiFlags = {
      ..._state.uiFlags,
      ...data,
    };
  },
  [SET_LAST_ERROR](_state, error) {
    _state.lastError = error;
  },
  [OPEN_LIMIT_MODAL](_state, entitlement) {
    _state.modal = {
      show: true,
      entitlement: normalizeEntitlement(entitlement),
    };
  },
  [CLOSE_LIMIT_MODAL](_state) {
    _state.modal = emptyModal();
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
